import { ChakraProvider } from "@chakra-ui/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App.jsx";
import { ConsentProvider } from "./components/privacy/ConsentProvider.jsx";
import "./components/css/main.css";
import { ContextProvider } from "./context/Context";
import { Datasecruity } from "./routes/Datasecruity.jsx";
import { Imprint } from "./routes/Imprint.jsx";

const router = createBrowserRouter([
  { path: "/", element: <App /> },
  {
    path: "/gruender-angebot",
    lazy: async () => {
      const [{ LandingPage }, { entrepreneurOfferContent }] = await Promise.all(
        [
          import("./components/landing-pages/LandingPage.jsx"),
          import(
            "./components/landing-pages/page-definitions/entrepeneur-offer/entrepeneurOffer.jsx"
          ),
        ]
      );

      function GruenderAngebot() {
        return <LandingPage content={entrepreneurOfferContent} />;
      }

      return {
        Component: GruenderAngebot,
      };
    },
  },
  {
    path: "/gruender-angebot/danke",
    lazy: async () => {
      const [{ LandingPage }, { entrepreneurOfferThankYouContent }] =
        await Promise.all([
          import("./components/landing-pages/LandingPage.jsx"),
          import(
            "./components/landing-pages/page-definitions/entrepeneur-offer/entrepeneurOffer.jsx"
          ),
        ]);

      function GruenderAngebotDanke() {
        return <LandingPage content={entrepreneurOfferThankYouContent} />;
      }

      return {
        Component: GruenderAngebotDanke,
      };
    },
  },
  {
    path: "/professionelle-webseite",
    lazy: async () => {
      const [{ LandingPage }, { professionalWebsiteOfferContent }] =
        await Promise.all([
          import("./components/landing-pages/LandingPage.jsx"),
          import(
            "./components/landing-pages/page-definitions/professional-website-offer/professionalWebsiteOffer.jsx"
          ),
        ]);

      function ProfessionelleWebseite() {
        return <LandingPage content={professionalWebsiteOfferContent} />;
      }

      return {
        Component: ProfessionelleWebseite,
      };
    },
  },
  {
    path: "/professionelle-webseite/danke",
    lazy: async () => {
      const [{ LandingPage }, { professionalWebsiteOfferThankYouContent }] =
        await Promise.all([
          import("./components/landing-pages/LandingPage.jsx"),
          import(
            "./components/landing-pages/page-definitions/professional-website-offer/professionalWebsiteOffer.jsx"
          ),
        ]);

      function ProfessionelleWebseiteDanke() {
        return (
          <LandingPage content={professionalWebsiteOfferThankYouContent} />
        );
      }

      return {
        Component: ProfessionelleWebseiteDanke,
      };
    },
  },
  {
    path: "/umsatz-magnet",
    lazy: async () => {
      const [{ LandingPage }, { revenueMagnetOfferContent }] =
        await Promise.all([
          import("./components/landing-pages/LandingPage.jsx"),
          import(
            "./components/landing-pages/page-definitions/revenue-magnet/revenueMagnetOfferContent.jsx"
          ),
        ]);

      function UmsatzMagnet() {
        return <LandingPage content={revenueMagnetOfferContent} />;
      }

      return {
        Component: UmsatzMagnet,
      };
    },
  },
  {
    path: "/umsatz-magnet/danke",
    lazy: async () => {
      const [{ LandingPage }, { revenueMagnetOfferThankYouContent }] =
        await Promise.all([
          import("./components/landing-pages/LandingPage.jsx"),
          import(
            "./components/landing-pages/page-definitions/revenue-magnet/revenueMagnetOfferContent.jsx"
          ),
        ]);

      function UmsatzMagnetDanke() {
        return <LandingPage content={revenueMagnetOfferThankYouContent} />;
      }

      return {
        Component: UmsatzMagnetDanke,
      };
    },
  },
  {
    path: "/kroll-fallstudie",
    lazy: async () => {
      const [{ LandingPage }, { krollLandingPage }] = await Promise.all([
        import("./components/landing-pages/LandingPage.jsx"),
        import(
          "./components/landing-pages/page-definitions/krollLandingPage.jsx"
        ),
      ]);

      function KrollFallstudie() {
        return <LandingPage content={krollLandingPage} />;
      }

      return {
        Component: KrollFallstudie,
      };
    },
  },
  { path: "*", element: <App /> },
  { path: "/datenschutz", element: <Datasecruity /> },
  { path: "/impressum", element: <Imprint /> },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HelmetProvider>
      <ChakraProvider>
        <ContextProvider>
          <ConsentProvider>
            <RouterProvider router={router} />
          </ConsentProvider>
        </ContextProvider>
      </ChakraProvider>
    </HelmetProvider>
  </React.StrictMode>
);
